import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Check, BellRing } from "lucide-react";

export default function ParentNotifications() {
  const [items, setItems] = useState([]);

  const load = async () => { const { data } = await api.get("/notifications"); setItems(data); };
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="p-4 pb-6" data-testid="parent-notifications-page">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <div className="text-[10px] font-mono tracking-[0.3em] uppercase text-zinc-500">Vos alertes</div>
          <h1 className="font-display font-black text-3xl tracking-tighter">Notifications</h1>
        </div>
        <button onClick={markAll} data-testid="parent-mark-all-read" className="inline-flex items-center gap-1 border border-zinc-900 px-3 py-2 text-xs font-bold uppercase tracking-widest hover:bg-zinc-900 hover:text-white">
          <Check size={14} /> Tout lu
        </button>
      </div>

      <div className="border border-zinc-900 divide-y divide-zinc-200 bg-white">
        {items.length === 0 ? (
          <div className="p-8 text-sm text-zinc-500 flex flex-col items-center gap-2">
            <BellRing size={24} /> Aucune notification.
          </div>
        ) : items.map((n) => (
          <div key={n.id} className={`p-3 flex items-start gap-3 ${n.read ? "opacity-70" : ""}`}>
            <div className={`mt-1 w-2 h-2 ${n.read ? "bg-zinc-300" : "bg-[#FFC60A]"}`} />
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <div className="font-semibold text-sm">{n.title}</div>
                <div className="text-[10px] font-mono text-zinc-500">{n.created_at.slice(11, 16)}</div>
              </div>
              <div className="text-xs text-zinc-600 mt-0.5">{n.body}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
